import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';


interface MenuIcons {
    [key: string]: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
};

const createIcon = (IconComponent: React.ElementType, size: string = '1.125rem', color?: string) => {
  return (props: { style?: React.CSSProperties }) => (
    <IconComponent
      style={{
        width: size,
        height: size,
        ...props.style,
        color,
      }}
    />
  );
};

const menuIcons: MenuIcons = {
    "Contabilidad": createIcon(AccountBalanceIcon, '1.5rem', 'white'),
    "Libro Diario": createIcon(MenuBookIcon),
    "Sincronizar Libro Diario": createIcon(CloudUploadIcon),
    
}

export default menuIcons